module.exports = __webpack_public_path__ + "static/media/IMG_7282-min.469e7f88.jpg";